import React from "react";
import Draggable from "react-draggable";
import {
  Paper,
  Dialog,
  Box,
  Typography,
  IconButton,
  useTheme,
  Grid,
  TextField,
  Button,
} from "@material-ui/core";
import {
  workersRef,
  punchesRef,
} from "../../services/firebase";
import { dateConfig, timeConfig } from "../../config";
import { Close, DateRange, AccessTime as Watch } from "@material-ui/icons";
import GroupTabs from "./GroupTabs";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import i18n from "i18n";
import moment from "moment";
import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import { isDateValid, getProjectInfoEntryType } from "utils";
import { Autocomplete } from "@material-ui/lab";
import { getLocationDetails, getProjectsByCountry } from "services";
import {
  getLocations,
  getProjectDetailsByCountry,
} from "redux/actions/appActions";
import { getLocationForCountry } from "services/bulkUpload";
import FormControl from "@material-ui/core/FormControl";
import {
  getActivityGroupByLanguage,
  getErrors,
  getJobFamiliesByLanguage,
  getExceptionsByLanguage,
  getUniqueID,
  getCustomerSite,
  getBuildings,
  getPunch,
  getProjectsByActivityGroup,
  getActivityDetails,
} from "../../../src/utils/punch";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {
  EXCEPTIONS,
  DEFAULT_EXCEPTION,
  SET_EMPTY,
  NO_EXCEPTION,
  MISSED_CLOCK_IN,
  MISSED_CLOCK_OUT,
  PROJECT,
  CLOCK_OUT,
  DEVICE_DETAILS,
} from "../../../src/config";
import MenuItem from "@material-ui/core/MenuItem";
import {
  createSplitPunches,
  prepareForCalendar,
  createorUpdateTimeSheetfromPunch,
} from "./utils";
import { isDate, set } from "date-fns";
import ConfirmDialog from "components/ConfirmDialog";
import Confirmation from "components/Confirmation";
import { properCase } from "utils";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#drag-handle"
      cancel={'[class*="MuiDialogContent-root"]'}
      bounds={"parent"}
    >
      <Paper
        style={{
          border: "1px solid white",
          borderRadius: "8px",
          overflow: "hidden",
        }}
        {...props}
      />
    </Draggable>
  );
}

const SplitDialog = (props) => {
  const {
    splitOpen,
    setSplitOpen,
    selectedWeek,
    disabled,
    setLoading,
    loading,
    dropdowns,
    errors,
    activityToSplit,
    splitActivitySaveHandler,
    setAddOpen,
    setActivityGroupTotals,
  } = props;

  let activity;

  {
    console.log("acts", activityToSplit);
  }
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [helperTextForStartTime, setHelperTextForStartTime] =
    React.useState(SET_EMPTY);
  const [helperTextForEndTime, setHelperTextForEndTime] =
    React.useState(SET_EMPTY);
  const [disableForStartTime, setDisableForStartTime] = React.useState(false);
  const [disableForEndTime, setDisableForEndTime] = React.useState(false);
  const appConfig = useSelector((state) => state.appConfig);
  const user = useSelector((state) => state.user);
  const loggedInSupervisor = user.auth.user.workerId;
  const { jobFamilies, activityGroups, projectDetailsByCountry } = appConfig;

  const [activityGroupOption, setActivityGroupOption] = React.useState([]);
  const [activityGroup, setActivityGroup] = React.useState([]);
  const [project, setProject] = React.useState("");
  const [freeFormText, setFreeFormText] = React.useState("");
  const [jobfamily, setJobfamily] = React.useState("");
  const [projectDetails, setProjectDetails] = React.useState(SET_EMPTY);
  const [selectedWeekStartDate, setSelectedWeekStartDate] = React.useState(
    selectedWeek ? selectedWeek : new Date()
  );
  const [selectStartDate, setSelectStartDate] = React.useState(
    new Date(activityToSplit?.start)
  );
  const [selectEndDate, setSelectEndDate] = React.useState(
    new Date(activityToSplit?.end)
  );

  const [selectStartErr, setSelectStartErr] = React.useState(false);
  const [selectEndErr, setSelectEndErr] = React.useState(false);
  const [startDate, setStartDate] = React.useState(
    new Date(activityToSplit?.start)
  );
  const [endDate, setEndDate] = React.useState(new Date(activityToSplit?.end));
  const [selectedDistrict, setSelectedDistrict] = React.useState("");
  const [districts, setDistricts] = React.useState([]);
  const [selectedBuilding, setSelectedBuilding] = React.useState("");
  const [buildings, setBuildings] = React.useState([]);
  const [customerSiteVisible, setCustomerSiteVisible] = React.useState(false);
  const [customerSite, setCustomerSite] = React.useState(SET_EMPTY);
  const [errCustomerSite, setErrCustomerSite] = React.useState(false);
  const [jobFamiliyOption, setJobFamilyOption] = React.useState([]);
  const [projectOption, setProjectOptions] = React.useState([]);
  const [showFreeForm, setShowFreeForm] = React.useState(false);
  const [exception, setException] = React.useState(DEFAULT_EXCEPTION);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);
  const [selectedIndexGroup, setSelectedIndexGroup] = React.useState(0);
  const selectedWorker = dropdowns?.selectedWorker;
  const [newActivities, setNewActivities] = React.useState([]);
  const [projectInfoEntryType, setProjectInfoEntryType] =
    React.useState(SET_EMPTY);
  const [confirmationBox, setConfirmationBox] = React.useState({
    isOpen: false,
    title: t("pgPunch.tlConfirmation"),
    subTitle: t("Captured Successfully"),
  });
  const [isokayDisabled, setIsokayDisabled] = React.useState(false);

  const districtLabel = properCase(t("pgPunch.lblDistrict")) + "*";
  const buildingLabel = properCase(t("pgPunch.lblBuilding")) + "*";
  const customerSiteLabel = properCase(t("pgPunch.phCustomerSite")) + "*";
  const timesheetJobFamily = properCase(t("other.timeSheetJobFamily")) + "*";
  let saveLabel = t("other.tlsaveSplitActivity");

  let exceptionOptions = getExceptionsByLanguage(i18n.language, EXCEPTIONS);

  const filterDetailsByActivityGroup = (projectDetailsByCountry, group, jobfamily) => {
    if (projectDetailsByCountry == null) return [];
    const detailsByProject = [];
    projectDetailsByCountry.filter((projectDetail, index, projectDetails) => {
      if (projectDetail.activityGroup === group.value) {
        detailsByProject.push(projectDetail);
      }
    });

    const detailByJobRoleRestricted = [];

    detailsByProject.map((detail, index) => {
      if (detail.isJobRoleRestricted !== undefined) {
        if (
          detail.isJobRoleRestricted === true &&
          detail.jobRoles.includes(jobfamily)
        ) {
          detailByJobRoleRestricted.push(detail);
        } else if (detail.isJobRoleRestricted === false) {
          detailByJobRoleRestricted.push(detail);
        }
      } else {
        detailByJobRoleRestricted.push(detail);
      }
    });

    return detailByJobRoleRestricted;
  };

  React.useEffect(() => {
    let show = showFreeForm;
    if (activityGroup) {
      if (projectOption.length == 0) {
        show = true;
      } else {
        show = false;
      }
    } else {
      show = false;
    }
    setShowFreeForm(show);
  }, [activityGroup, projectOption]);

  React.useEffect(() => {
    let jobFamilyOptions =
      jobFamilies !== null
        ? getJobFamiliesByLanguage(i18n.language, jobFamilies)
        : [];
    jobFamilyOptions =
      selectedWorker && selectedWorker.isApprover
        ? jobFamilyOptions
        : jobFamilyOptions.filter((item) => !item.mgrOnly);

    const activityGroupsOptions =
      activityGroups !== null
        ? getActivityGroupByLanguage(i18n.language, activityGroups)
        : [];

    const detailsByProject = filterDetailsByActivityGroup(
      projectDetailsByCountry,
      activityGroup,
      jobfamily
    );
    let filteredActivityGroups = jobFamilyOptions.filter((item) => {
      return item.actGrpsRestrctd === true &&
        item.actGrps.length > 0 && item.value === jobfamily;
    });
    let filtActivityGroupsOptions = [...activityGroupsOptions.map(group=>{return {...group,disabled:false}})];
    if (filteredActivityGroups && filteredActivityGroups.length > 0) {
      const restrictedActGrps = filteredActivityGroups[0].actGrps;
      filtActivityGroupsOptions = filtActivityGroupsOptions.map(
        (item) =>{ 
          let returnItem ={...item};
          if(restrictedActGrps.includes(item.value) || item.value === "Leave" || item.value === "Meal"){
            returnItem={...item,disabled:false}
          }else{
            returnItem={...item,disabled:true}
          }
          return returnItem
        }
      );
    }
    let projectOptions = detailsByProject.filter((e) => e.isActive);
    setJobFamilyOption(jobFamilyOptions);
    setProjectOptions([...projectOptions]);
    setActivityGroupOption([...filtActivityGroupsOptions]);
    const projInfoEntryType = getProjectInfoEntryType(
      jobfamily,
      jobFamiliyOption
    );
    setProjectInfoEntryType(projInfoEntryType);
    if (projInfoEntryType === "id") {
      setProjectDetails(activityToSplit?.projectDetails);
    } else {
      setProjectDetails(SET_EMPTY);
    }

  }, [
    jobFamilies,
    activityGroups,
    projectDetailsByCountry,
    activityGroup,
    i18n,
    jobfamily,
  ]);

  React.useEffect(() => {

    console.log('cond1:', getDateAndTime(new Date(selectEndDate), new Date(endDate)));
    console.log('test cond:', new Date(activityToSplit?.start));
    console.log('test cond2:', new Date(activityToSplit?.end));

    selectStartDate &&
      isDateValid(selectStartDate) &&
      getDateAndTime(new Date(selectStartDate), new Date(startDate)) >= new Date(activityToSplit?.start) &&
      getDateAndTime(new Date(selectStartDate), new Date(startDate)) <= new Date(activityToSplit?.end)
      ? setSelectStartErr(false)
      : setSelectStartErr(true);

    selectEndDate &&
      isDateValid(selectEndDate) &&
      getDateAndTime(new Date(selectEndDate), new Date(endDate)) >= new Date(activityToSplit?.start) &&
      getDateAndTime(new Date(selectEndDate), new Date(endDate)) <= new Date(activityToSplit?.end)
      ? setSelectEndErr(false)
      : setSelectEndErr(true);
  }, [selectStartDate, selectEndDate, startDate, endDate]);

  React.useEffect(() => {
    if (selectedWorker && selectedWorker.countryCode) {
      setLoading(true);
      if (selectedWorker.country === "testCountry") {
        selectedWorker.countryCode = "testCountry";
      }
      dispatch(
        getLocations(
          selectedWorker.countryCode,
          selectedWorker.alternateCountryCode
        )
      );

      getLocationForCountry(
        selectedWorker.countryCode,
        selectedWorker.alternateCountryCode
      )
        .then((data) => {
          // console.log("Data 1", data);
          setLoading(false);
          setDistricts([...data]);
        })
        .catch(() => {
          setLoading(false);
          ////console.log("BulkEntry: Err loading locations data");
        });

      getProjectsByCountry(selectedWorker.country)
        .then((data) => {
          if (data) {
            setLoading(false);
            dispatch(getProjectDetailsByCountry(data));
          }
        })
        .catch((err) => {
          console.error("No response from getProjectDetailsByCountry:: ", err);
        });
    } else {
      setDistricts([]);
    }
  }, [selectedWorker]);

  React.useEffect(() => {
    //console.log("selectedBuilding:",selectedBuilding);
    if (!selectedBuilding) {
      setSelectedBuilding(SET_EMPTY);
      setCustomerSiteVisible(false);
      setErrCustomerSite(false);
    } else if (selectedBuilding && selectedBuilding === "Customer Site") {
      setCustomerSiteVisible(true);
    } else {
      //console.log("building changed from customer site");
      setCustomerSiteVisible(false);
      setCustomerSite(SET_EMPTY);
      setErrCustomerSite(false);
    }
  }, [selectedBuilding]);

  React.useEffect(() => {
    if (exception == "") {
      setException(DEFAULT_EXCEPTION);
    }
  }, [exception]);

  React.useEffect(() => {
    let show = false;

    let disableActivityGroups = ["leave"];
    // console.log("this is activity group11", activityGroup);
    // console.log("this is activity job family", jobfamily);
    if (
      selectedWorker &&
      startDate &&
      isDateValid(startDate) &&
      activityGroup &&
      selectedDistrict &&
      selectedBuilding &&
      endDate &&
      isDateValid(endDate) &&
      selectEndDate &&
      isDateValid(selectEndDate) &&
      getDateAndTime(new Date(selectEndDate), new Date(endDate)) >= new Date(activityToSplit?.start) &&
      getDateAndTime(new Date(selectEndDate), new Date(endDate)) <= new Date(activityToSplit?.end) &&
      selectStartDate &&
      isDateValid(selectStartDate) &&
      getDateAndTime(new Date(selectStartDate), new Date(startDate)) >= new Date(activityToSplit?.start) &&
      getDateAndTime(new Date(selectStartDate), new Date(startDate)) <= new Date(activityToSplit?.end) &&
      // ((disableActivityGroups.includes(
      //   activityGroup.value?.toLowerCase().trim()
      // ) &&
      //   !jobfamily) ||
      //   jobfamily)
      jobfamily
    )
      show = true;

    if (
      customerSiteVisible &&
      customerSiteVisible === true &&
      (!customerSite || customerSite === SET_EMPTY)
    )
      show = false;

    let startTime = moment(activityToSplit?.start).format(dateConfig.format4);
    let endTime = moment(activityToSplit?.end).format(dateConfig.format4);
    const selectedStartTime = moment(
      getDateAndTime(new Date(selectStartDate), new Date(startDate))
    ).format(dateConfig.format4);
    const selectedEndTime = moment(
      getDateAndTime(new Date(selectEndDate), new Date(endDate))
    ).format(dateConfig.format4);

    setHelperTextForStartTime(SET_EMPTY);
    setDisableForStartTime(false);
    setHelperTextForEndTime(SET_EMPTY);
    setDisableForEndTime(false);

    if (selectedEndTime <= selectedStartTime) {
      setHelperTextForStartTime(`Start time should be  less than End time`);
      setDisableForStartTime(true);
      setHelperTextForEndTime(`End time should be  greater than Start time`);
      setDisableForEndTime(true);
      show = false;
    }
    if (selectedStartTime < startTime || selectedStartTime > endTime) {
      setHelperTextForStartTime(
        `Start time should be in between ${moment(new Date(activityToSplit?.start)).format(
          timeConfig.format4
        )} and ${moment(new Date(activityToSplit?.end)).format(timeConfig.format4)}`
      );
      setDisableForStartTime(true);
      show = false;
    }

    if (selectedEndTime < startTime || selectedEndTime > endTime) {
      setHelperTextForEndTime(
        `End time should be in between ${moment(new Date(activityToSplit?.start)).format(
          timeConfig.format4
        )} and ${moment(new Date(activityToSplit?.end)).format(timeConfig.format4)}`
      );
      setDisableForEndTime(true);
      show = false;
    }
    // if(projectInfoEntryType === "id" && !projectDetails){
    //   show = false;
    // }
    if (activityGroup.value === 'Project') {
      if (showFreeForm && !freeFormText) {
        show = false;
      } else if (!showFreeForm && !project) {
        show = false;
      }
    }
    console.log('show:', show);
    if (show === false) setIsSaveDisabled(true);
    else setIsSaveDisabled(false);
    const inTS = getDateAndTime(new Date(selectStartDate), new Date(startDate));
    const outTS = getDateAndTime(new Date(selectEndDate), new Date(endDate));
    // setNewData({
    //   start: inTS,
    //   end: outTS,
    //   // selectStartDate: selectStartDate,
    //   // endDate: selectEndDate,
    //   title: activity?.title,
    //   updateFlag: true,
    //   id: activity?.id,
    //   buildingId: selectedBuilding,
    //   districtId: selectedDistrict,
    //   jobfamily: jobfamily,
    //   project: project,
    //   freeFormText: freeFormText,
    //   group: activity?.activityGroup,
    // });
  }, [
    selectedWorker,
    startDate,
    activityGroup,
    selectedDistrict,
    selectedBuilding,
    jobfamily,
    endDate,
    project,
    freeFormText,
    customerSite,
    customerSiteVisible,
    selectStartDate,
    selectEndDate,
    projectDetails,
    showFreeForm,
  ]);

  React.useEffect(() => {
    if (activityToSplit?.group) {
      setActivityGroup(activityToSplit.group);
      setSelectedDistrict(activityToSplit.districtId);
      setSelectedBuilding(activityToSplit.buildingId);
      setCustomerSite(activityToSplit.customerSite);
      if (activityToSplit.customerSite == "") {
        setCustomerSiteVisible(false);
      }
      setException(activityToSplit.exceptionName);
      if (activityToSplit.jobName) {
        setJobfamily(activityToSplit.jobName);
      } else if (activityToSplit.jobfamily) {
        setJobfamily(activityToSplit.jobfamily);
      }
      if (activityToSplit.project) {
        setProject(activityToSplit.project);
      } else if (activityToSplit.jobProjectInfo) {
        setProject(activityToSplit.jobProjectInfo);
      } else {
        setProject("");
      }
      setErrCustomerSite(false);
      if (activityToSplit?.freeFormText)
        setFreeFormText(activityToSplit?.freeFormText);
      else if (activityToSplit?.jobProjectInfo)
        setFreeFormText(activityToSplit?.jobProjectInfo);
      else setFreeFormText("");

      const keys = Object.keys(activityGroupOption);
      for (let eachKey in activityGroupOption) {
        if (
          activityGroupOption[eachKey].value?.toLowerCase() ===
          activityToSplit.group?.value?.toLowerCase()
        ) {
          setSelectedIndexGroup(Math.floor(eachKey));
        }
      }
      if (activityToSplit.start) {
        setSelectStartDate(activityToSplit.start);
        setStartDate(activityToSplit.start);
      }
      if (activityToSplit.end) {
        setSelectEndDate(activityToSplit.end);
        setEndDate(activityToSplit.end);
      }

      let buildings = [];
      let buildingsList = districts
        .filter((item) => item?.district === activityToSplit?.districtId)
        .map((item, index) => {
          buildings = item.buildings;
        });

      let activatedBuilding = Object.keys(buildings).filter(
        (e) => buildings[e].activityEnabled === true
      );
      selectedWorker?.isApprover
        ? setBuildings([...activatedBuilding, "Customer Site", "Remote"])
        : setBuildings([...activatedBuilding, "Customer Site"]);
      setProjectDetails(activityToSplit?.projectDetails);
    }
  }, [activityToSplit, splitOpen]);

  const reversedActivityGroups = [...activityGroupOption].reverse();

  const getDateAndTime = (date, time) => {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      time.getHours(),
      time.getMinutes(),
      time.getSeconds(),
      time.getMilliseconds()
    );
  };

  const handleTextFieldChange = (event) => {
    const textValue = event.target.value;
    if (textValue) setFreeFormText(textValue);
    else setFreeFormText("");
    if (textValue.length == 0) setFreeFormText("");
    setProject("");
  };

  const projectDetailsChange = (event) => {
    const value = event.target.value;

    setProjectDetails(value);
  };
  const closeSplitDialog = () => {
    // setSelectedDistrict("");
    // setSelectedBuilding("");
    // setJobfamily("");
    // setProject("");
    // setFreeFormText("");
    // setActivityGroup("");
    // setException("");
    setHelperTextForStartTime(SET_EMPTY);
    setHelperTextForEndTime(SET_EMPTY);
    setDisableForStartTime(false);
    setDisableForEndTime(false);

    setAddOpen(true);
    setSplitOpen(false);
  };

  const getWeekError = (errors, field) => {
    if (!errors) return false;
    if (!errors[field]) return false;
    return errors[field];
  };

  const customerSiteChange = (event) => {
    const value = event.target.value;
    setCustomerSite(value);
    if (value.length === 0) {
      setErrCustomerSite(true);
      setCustomerSite("");
    } else {
      setErrCustomerSite(false);
    }
  };

  const exceptionChange = (event) => {
    setException(event.target.value);
  };

  const newPunchesAfterSplit = (activities) => {
    console.log(
      "success split punches happen console newpunchesaftersplit",
      activities.length
    );
  };

  const saveActivity = async () => {
    if (
      moment(activityToSplit?.start).format("DDMMYY") ==
      moment(selectStartDate).format("DDMMYY") &&
      moment(activityToSplit?.end).format("DDMMYY") ==
      moment(selectEndDate).format("DDMMYY") &&
      moment(activityToSplit?.start).format("hhmm") ==
      moment(startDate).format("hhmm") &&
      moment(activityToSplit?.end).format("hhmm") ==
      moment(endDate).format("hhmm")
    ) {
      setHelperTextForStartTime(
        "Start or End Time must be different than original activity"
      );
      setHelperTextForEndTime(
        "Start or End Time must be different than original activity"
      );
      setDisableForEndTime(true);
      setDisableForStartTime(true);
      return;
    }
    setLoading(true);
    let tempException = "";
    let tempCustomerSite = "";
    if (customerSiteVisible) {
      tempCustomerSite = customerSite;
    }
    if (exception == DEFAULT_EXCEPTION) {
      tempException = "";
    }
    setIsSaveDisabled(true);
    const inTS = getDateAndTime(new Date(selectStartDate), new Date(startDate));
    const outTS = getDateAndTime(new Date(selectEndDate), new Date(endDate));
    const splitActivity = {
      startTime: inTS,
      endTime: outTS,
      buildingId: selectedBuilding,
      districtId: selectedDistrict,
      jobfamily: jobfamily,
      jobProjectInfo: project,
      project: project,
      freeFormText: freeFormText,
      group: activityGroup,
      customerSite: tempCustomerSite,
      exceptionName: tempException,
      isException: exception != DEFAULT_EXCEPTION && exception != "",
      projectDetails: projectDetails,
    };

    let punch;
    await punchesRef()
      .doc(activityToSplit.id)
      .get()
      .then((data) => {
        if (data.exists) {
          if (data.status != "deleted") {
            punch = { ...data.data(), id: data.id };
            console.log("punch:", punch);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        setIsokayDisabled(false);
        setConfirmationBox({
          ...confirmationBox,
          isOpen: true,
          subTitle: t("Error occured"),
        });
        setIsSaveDisabled(false);
        setLoading(false);
      });

    await createSplitPunches(
      splitActivity,
      activityToSplit.id,
      loggedInSupervisor,
      punch
    )
      .then(async (res) => {
        console.log("success split punches happen ", res);
        let newActivities = prepareForCalendar(res);
        for (let i = 0; i < res.length; i++) {
          const eachActivity = res[i];
          let eachPunchRecord = { ...eachActivity, id: eachActivity.punchId };
          let activityWeekChange = false;

          if (punch.id === eachActivity.punchId) {
            if (punch.weekNumber && punch.weekNumber != eachActivity.weekNumber)
              activityWeekChange = true;
            console.log("punchId ", punch.id);
          }
          console.log('activityWeekChange:', activityWeekChange);
          await createorUpdateTimeSheetfromPunch(
            eachPunchRecord,
            loggedInSupervisor,
            false,
            false,
            activityWeekChange,
            punch
          )
            .then((data) => {
              if (data && Object.keys(data).length > 0) {
                setActivityGroupTotals(data?.weekTotalHours?.activityGroupTotals);
              }
            })
            .catch((err) => {
              console.log("error:", err);
            });
        }
        splitActivitySaveHandler(activityToSplit.id, newActivities);
        // setConfirmDialog({ ...confirmDialog, isOpen: true })
        setIsokayDisabled(false);
        setConfirmationBox({ ...confirmationBox, isOpen: true });
        setIsSaveDisabled(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error in split", err);
        setIsokayDisabled(false);
        setConfirmationBox({
          ...confirmationBox,
          isOpen: true,
          subTitle: t("Error occured"),
        });
        setIsSaveDisabled(false);
        setLoading(false);
      });
  };

  return (
    <>
      <Dialog
        PaperComponent={PaperComponent}
        hideBackdrop
        aria-labelledby="responsive-dialog-title"
        open={splitOpen}
        onClose={(event, reason) => {
          closeSplitDialog();
        }}
      >
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            id="drag-handle"
            style={{
              cursor: "move",
              gap: 16,
              height: "36px",
              backgroundColor: "#1B75BC",
              paddingLeft: 24,
              paddingRight: 16,
              paddingTop: 8,
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              style={{ gap: 16, color: "white" }}
            >
              <Typography> {t("other.tlsplitActivity")}</Typography>
            </Box>
            <IconButton size="small" style={{ color: "white" }}>
              <Close fontSize="inherit" onClick={closeSplitDialog} />
            </IconButton>
          </Box>
          <Box
            className="content"
            display="flex"
            flexDirection="column"
            style={{ gap: 16 }}
            px={3}
          >
            <GroupTabs
              tabs={reversedActivityGroups}
              initialSelect={selectedIndexGroup}
              onChange={(tab) => {
                setActivityGroup(tab);
                setProject("");
                setFreeFormText("");
                if (tab.value.toLowerCase() == "leave") {
                  const defaultJobRole = selectedWorker.jobRole ? selectedWorker.jobRole : "";
                  setJobfamily(defaultJobRole);

                } else if (
                  jobfamily.toLowerCase() == "leave" &&
                  tab.value.toLowerCase() != "leave"
                ) {
                  setJobfamily("");
                }
              }}
              isupdateFlag={
                //activity?.updateFlag && activity?.updateFlag === true
                true
              }
              setactivity={(update) => {
                setActivityGroup(update);
              }}
              selectedActivityGroup={activityGroup}
            />
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardDatePicker
                  disableBackdropClick
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={selectStartDate}
                  onChange={(newValue) => {
                    setSelectStartDate(newValue);
                  }}
                  minDate={new Date(moment(activityToSplit?.start))}
                  maxDate={new Date(moment(activityToSplit?.end))}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.startDate"))}
                  keyboardIcon={<DateRange fontSize="inherit" />}
                  error={selectStartErr}
                  helperText={props.endDateErrMsg}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardDatePicker
                  disableBackdropClick
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={selectEndDate}
                  onChange={(newValue) => {
                    setSelectEndDate(newValue);
                  }}
                  minDate={activityToSplit?.start}
                  maxDate={new Date(moment(activityToSplit?.end))}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.endDate"))}
                  keyboardIcon={<DateRange fontSize="" />}
                  error={selectEndErr}
                  helperText={props.endDateErrMsg}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardTimePicker
                  disableBackdropClick
                  placeholder="hh:mm"
                  margin="none"
                  id="date-picker-dialog"
                  //format="hh:mm a"
                  ampm={false}
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.startTime"))}
                  keyboardIcon={<Watch fontSize="inherit" />}
                  error={disableForStartTime}
                  helperText={helperTextForStartTime}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <KeyboardTimePicker
                  disableBackdropClick
                  placeholder="dd/MM/yyyy"
                  margin="none"
                  id="date-picker-dialog"
                  //format="hh:mm a"
                  ampm={false}
                  value={endDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  inputVariant="outlined"
                  size="small"
                  label={properCase(t("pgReview.tableHeads.endTime"))}
                  keyboardIcon={<Watch fontSize="" />}
                  error={disableForEndTime}
                  helperText={helperTextForEndTime}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <Autocomplete
                  disabled={loading || !selectedWorker}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  fullWidth
                  //disableClearable
                  value={{ district: selectedDistrict }}
                  defaultValue={{ district: props.value }}
                  options={districts}
                  getOptionLabel={(option) => option.district}
                  renderInput={(params) => (
                    <TextField
                      // label={t("other.timeSheetDIstrictDropdown")}
                      label={districtLabel}
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                      }}
                      size="small"
                      // placeholder={t("other.timeSheetDIstrictDropdown")}
                      placeholder={districtLabel}
                      error={getWeekError(errors, "districtId")}
                      variant="outlined"
                    />
                  )}
                  onInputChange={(event, newValue) => {
                    if (!newValue) {
                      //setDistricts([]);
                      setSelectedDistrict("");
                      setSelectedBuilding("");
                      setBuildings([]);
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      const tempbuild = newValue.buildings;
                      let activatedBuilding = Object.keys(tempbuild).filter(
                        (e) => tempbuild[e].activityEnabled === true
                      );

                      if (newValue && newValue.buildings) {
                        setSelectedDistrict(newValue.district);
                        setSelectedBuilding("");
                        selectedWorker.isApprover
                          ? setBuildings([
                            ...activatedBuilding,
                            "Customer Site",
                            "Remote",
                          ])
                          : setBuildings([
                            ...activatedBuilding,
                            "Customer Site",
                          ]);
                      }
                    }
                  }}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <Autocomplete
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  fullWidth
                  //disableClearable
                  value={selectedBuilding}
                  defaultValue={{ value: props.value }}
                  options={buildings}
                  loading={buildings.length == 0}
                  disabled={loading || !selectedWorker || !selectedDistrict}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      //label={t("pgPunch.lblBuilding")}
                      label={buildingLabel}
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                      }}
                      placeholder={buildingLabel}
                      error={getWeekError(errors, "buildingId")}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  onInputChange={(event, newValue) => {
                    if (!newValue) {
                      // setBuildings([]);
                      setSelectedBuilding("");
                    }
                  }}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setSelectedBuilding(newValue);
                    }
                  }}
                />
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                {customerSiteVisible && (
                  <FormControl fullWidth>
                    <TextField
                      label={customerSiteLabel}
                      value={customerSite}
                      fullWidth
                      autoFocus={true}
                      size="small"
                      variant="outlined"
                      name="customerSite"
                      onChange={customerSiteChange}
                      error={errCustomerSite}
                    />
                  </FormControl>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <Autocomplete
                  className="content"
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  fullWidth
                  value={{ label: jobfamily }}
                  options={jobFamiliyOption}
                  getOptionLabel={
                    (option) =>
                      option.label === "Leave"
                        ? selectedWorker.jobRole && selectedWorker.jobRole
                        : option.label
                  }
                  // disabled={
                  // disabled || activityGroup?.value === "Leave" ? true : false                     
                  // }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        style: { fontSize: 14 },
                      }}
                      size="small"
                      variant="outlined"
                      label={timesheetJobFamily}
                    />
                  )}
                  onInputChange={(event, newValue) => {
                    if (!newValue) {
                      setJobfamily("");
                      setProjectOptions([]);
                      setProject("");
                    }
                  }}
                  onChange={(_, data) => {
                    if (data) {
                      setJobfamily(data.value);
                      setProjectInfoEntryType(data.projectInfoEntryType);
                    }
                  }}
                />
              </Grid>
              {projectInfoEntryType === "id" && (
                <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                  <FormControl fullWidth>
                    <TextField
                      label={t("other.lblProjectDetails")}
                      value={projectDetails}
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="projectDetails"
                      onChange={projectDetailsChange}
                    />
                  </FormControl>
                </Grid>
              )}

              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                {showFreeForm ? (
                  <FormControl className="content" fullWidth>
                    <TextField
                      // disabled={
                      //   disabled === true || activityGroup.value === "Meal" ? true : false
                      // }
                      label={activityGroup?.value === 'Project'
                        ? properCase(t("other.timeSheetDetails")) + '*'
                        : properCase(t("other.timeSheetDetails"))

                      }
                      fullWidth
                      //defaultValue={lastpunchDetails?.jobProjectInfo}
                      value={freeFormText}
                      size="small"
                      variant="outlined"
                      onChange={handleTextFieldChange}
                      onInputChange={handleTextFieldChange}
                      {...props}
                      disabled={
                        disabled ||
                          activityGroup?.value?.toLowerCase() === "meal"
                          ? true
                          : false
                      }
                    />
                  </FormControl>
                ) : (
                  <Autocomplete
                    disabled={
                      disabled || activityGroup?.value?.toLowerCase() === "meal"
                        ? true
                        : false
                    }
                    className="content"
                    selectOnFocus
                    //inputValue={project}
                    value={{ name: project }}
                    clearOnBlur
                    handleHomeEndKeys
                    fullWidth
                    options={projectOption}
                    getOptionLabel={(option) => {
                      // console.log("This is option ", option.name);
                      // console.log("This is project options ", projectOption);
                      return option.name;
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: 14 },
                        }}
                        size="small"
                        variant="outlined"
                        label={
                          activityGroup.value === "Leave"
                            ? properCase(t("other.timesheetLeaveType"))
                            : activityGroup?.value === 'Project'
                              ? properCase(t("other.timeSheetDetails")) + '*'
                              : properCase(t("other.timeSheetDetails"))

                        }
                      // error={getErrors(errors.records, index, "details")}
                      />
                    )}
                    onChange={(_, data) => {
                      if (data) {
                        setProject(data.name);
                      }
                      // error={getErrors(errors.records, index, "details")}
                    }}
                    onInputChange={(event, newValue) => {
                      if (!newValue) {
                        setProject("");
                        setFreeFormText("");
                        //setActivityGroupOption([]);
                      }
                    }}
                  />
                )}
              </Grid>
              <Grid item md={4} xs={12} sm={12} lg={4} xl={4}>
                <FormControl size="small" variant="outlined" fullWidth>
                  <InputLabel id="exception-sel">{properCase(t("pgReview.tableStaticText.exception"))}</InputLabel>
                  <Select
                    fullWidth
                    labelId="exception-sel"
                    label={"Exception"}
                    id="exception-select"
                    value={exception}
                    //defaultValue={{ exception: (activity?.exceptionName && activity.exceptionName.length > 0 ? activity.exceptionName : "No Exception") }}
                    onChange={exceptionChange}
                  >
                    {exceptionOptions.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          style={{ gap: 16 }}
          px={2}
          py={2}
          display="flex"
          flexDirection="row"
        >
          <Box flexGrow={1} />
          <Button
            disableElevation
            size="medium"
            onClick={closeSplitDialog}
            sx={{ color: (t) => t.palette.text.secondary }}
          >
            {properCase(t("pgPunch.btnCancel"))}
          </Button>

          <Button
            variant="contained"
            color="primary"
            disabled={isSaveDisabled}
            onClick={saveActivity}
            disableRipple
            disableElevation
            size="medium"
          >
            {saveLabel}
          </Button>
        </Box>
      </Dialog>
      <Confirmation
        confirmationMsg={confirmationBox.isOpen}
        closeModalConfirmationMsg={() => {
          setConfirmationBox({ ...confirmationBox, isOpen: false });
        }}
        confirmationMsgText={confirmationBox.subTitle}
        confirmationTitleText={confirmationBox.title}
        isokayDisabled={isokayDisabled}
        setIsokayDisabled={setIsokayDisabled}
      />
    </>
  );
};

export default SplitDialog;
